import styled from 'styles/styled';

export const Hero = styled.div`
  background: #15191E;
  padding: 12px 16px;
  border-radius: 10px 10px 0 0;
  flex: 0 0 auto;

  @media (max-width: 720px) {
    border-radius: 0;
    padding: 10px 12px;
  }
`;

export const SingleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 720px) {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 8px 12px;
    align-items: center;
  }
`;

export const SpreadPillMobile = styled.span`
  display: none;
  margin-left: auto;
  background: #292B2E;
  border-radius: 999px;
  padding: 3px 8px;
  font-size: 10px;
  color: #7A7E8C;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  line-height: 1.2;

  b {
    font-weight: 700;
    margin-left: 2px;

    &.tb-pos {
      color: #52D381;
    }

    &.tb-neg {
      color: #FF6782;
    }
  }

  @media (max-width: 720px) {
    display: inline-flex;
    align-items: center;
    justify-self: end;
  }
`;

export const PriceCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 720px) {
    grid-column: 1;
    grid-row: 2;
  }
`;

export const Price = styled.div`
  font-size: 28px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #52D381;
  line-height: 1;
  letter-spacing: -0.01em;

  @media (max-width: 720px) {
    font-size: 22px;
  }
`;

export const PriceUnit = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;

  .pct {
    display: inline-flex;
    align-items: center;
    background: #292B2E;
    border-radius: 999px;
    padding: 2px 6px;
    font-size: 9px;
    color: #7A7E8C;
    font-weight: 500;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
    line-height: 1.2;

    b {
      font-weight: 700;
      margin-left: 2px;

      &.tb-pos {
        color: #52D381;
      }

      &.tb-neg {
        color: #FF6782;
      }
    }

    @media (max-width: 720px) {
      display: none;
    }
  }

  .unit {
    font-size: 12px;
    color: #7A7E8C;
    font-weight: 500;
  }
`;

export const MicroStats = styled.div`
  display: flex;
  gap: 14px;

  @media (max-width: 720px) {
    display: none;
  }
`;

export const StatCell = styled.div`
  text-align: left;

  .l {
    font-size: 9px;
    color: #7A7E8C;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-bottom: 2px;
    font-weight: 600;
  }

  .v {
    font-size: 12px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: #A7A8B2;
  }
`;

export const PnlGroup = styled.div`
  display: flex;
  gap: 14px;
  margin-left: auto;

  @media (max-width: 720px) {
    margin-left: 0;
    grid-column: 2;
    grid-row: 2;
    justify-self: end;
    align-items: flex-end;
  }
`;

export const PnlCell = styled.div`
  text-align: right;

  .l {
    font-size: 9px;
    color: #7A7E8C;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-bottom: 2px;
    font-weight: 600;
  }

  .v {
    font-size: 13px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    color: #EFEFEF;

    &.tb-pos {
      color: #52D381;
    }

    &.tb-neg {
      color: #FF6782;
    }
  }
`;
